import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "min-h-screen px-5 py-6 md:px-6" }
const _hoisted_2 = { class: "w-full space-y-5" }
const _hoisted_3 = { class: "rounded-[1.5rem] border border-[#d8e4f0] bg-white p-5 shadow-[0_14px_30px_rgba(15,23,42,0.05)]" }
const _hoisted_4 = { class: "flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_5 = { class: "flex flex-wrap gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "rounded-[1rem] border border-[#f5c2c7] bg-[#fff5f5] px-4 py-3 text-[#b42318]"
}
const _hoisted_7 = {
  key: 1,
  class: "grid gap-5 lg:grid-cols-[360px_1fr] xl:grid-cols-[400px_1fr]"
}
const _hoisted_8 = { class: "rounded-[1.4rem] border border-[#d8e4f0] bg-white p-5 shadow-[0_10px_22px_rgba(15,23,42,0.04)] space-y-4" }
const _hoisted_9 = { class: "space-y-2.5 pt-2" }
const _hoisted_10 = {
  key: 3,
  class: "grid gap-5 lg:grid-cols-[360px_1fr] xl:grid-cols-[400px_1fr] items-start"
}
const _hoisted_11 = { class: "flex items-center justify-between pb-1" }
const _hoisted_12 = { class: "inline-flex rounded-full bg-[#eaf3fb] px-2.5 py-0.5 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#2f6fab]" }
const _hoisted_13 = { class: "space-y-2 pt-1" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_16 = { class: "min-w-0" }
const _hoisted_17 = { class: "truncate text-[0.92rem] font-extrabold text-[#0f172a]" }
const _hoisted_18 = { class: "inline-flex rounded-full bg-[#eaf3fb] px-2 py-0.5 text-[0.68rem] font-extrabold uppercase tracking-[0.08em] text-[#2f6fab] mt-0.5" }
const _hoisted_19 = {
  key: 0,
  class: "rounded-[1rem] border border-dashed border-[#d8e4f0] bg-white p-6 text-center text-sm text-[#64748b]"
}
const _hoisted_20 = {
  key: 0,
  class: "lg:hidden"
}
const _hoisted_21 = { class: "flex flex-col gap-4 rounded-[1.4rem] border border-[#d8e4f0] bg-white p-5 sm:p-6 shadow-[0_10px_22px_rgba(15,23,42,0.04)] sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_22 = { class: "flex items-center gap-4 min-w-0" }
const _hoisted_23 = { class: "flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#eaf3fb] text-lg font-black text-[#2f6fab]" }
const _hoisted_24 = { class: "min-w-0" }
const _hoisted_25 = { class: "flex items-center gap-2.5 flex-wrap" }
const _hoisted_26 = { class: "truncate text-[1.4rem] font-black text-[#0f172a]" }
const _hoisted_27 = { class: "inline-flex rounded-full bg-[#eaf3fb] px-3 py-1 text-[0.72rem] font-extrabold uppercase tracking-[0.08em] text-[#2f6fab]" }
const _hoisted_28 = { class: "flex flex-col sm:items-end gap-2 shrink-0" }
const _hoisted_29 = { class: "text-[0.92rem] font-extrabold text-[#0f172a]" }
const _hoisted_30 = { class: "h-2.5 w-44 rounded-full bg-[#e2e8f0] overflow-hidden" }
const _hoisted_31 = { class: "space-y-4" }
const _hoisted_32 = { class: "flex items-center justify-between" }
const _hoisted_33 = { class: "space-y-3" }
const _hoisted_34 = { class: "flex items-center gap-1.5 pt-1 text-[0.85rem] text-[#64748b]" }
const _hoisted_35 = {
  key: 2,
  class: "flex flex-col items-center justify-center rounded-[1.4rem] border border-dashed border-[#d8e4f0] bg-white p-12 text-center shadow-[0_10px_22px_rgba(15,23,42,0.04)] min-h-[460px]"
}
const _hoisted_36 = { class: "flex h-16 w-16 items-center justify-center rounded-[1.2rem] bg-[#eaf3fb] text-[#2f6fab] mb-4" }
const _hoisted_37 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
}
const _hoisted_38 = { class: "w-full max-w-sm rounded-[1.4rem] bg-white p-6 shadow-2xl border border-[#d8e4f0] space-y-4" }
const _hoisted_39 = { class: "flex items-center justify-between pb-3 border-b border-[#eef2f7]" }
const _hoisted_40 = { class: "text-[0.88rem] text-[#64748b]" }
const _hoisted_41 = { class: "font-bold text-[#0f172a]" }
const _hoisted_42 = { class: "space-y-2" }
const _hoisted_43 = { class: "flex justify-end gap-2.5 pt-3 border-t border-[#eef2f7]" }

import { computed, onMounted, reactive, ref, watch } from "vue";
import {
  ArrowLeft,
  FileText,
  Info,
  Plus,
  RefreshCw,
  X,
} from "lucide-vue-next";
import AnimatedList from "@/components/AnimatedList.vue";
import AnimatedItem from "@/components/AnimatedItem.vue";
import { useAuthStore } from "@/store/auth";
import { useAccessControl } from "@/composables/useAccessControl";
import { ACCESS_PERMISSION_KEYS } from "@/constants/accessControl";
import ClientReportsView from "@/components/reports/ClientReportsView.vue";
import MonthlyReportCard from "@/components/reports/MonthlyReportCard.vue";
import ReportBuilderModal from "@/components/reports/ReportBuilderModal.vue";
import ReportGenerationLoadingModal from "@/components/reports/ReportGenerationLoadingModal.vue";
import ReportFilters from "@/components/reports/ReportFilters.vue";
import ReportPreviewDialog from "@/components/reports/ReportPreviewDialog.vue";
import ReportQuickEditDialog from "@/components/reports/ReportQuickEditDialog.vue";
import ReportPagination from "@/components/reports/ReportPagination.vue";
import UploadReportModal from "@/components/reports/UploadReportModal.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { useToast } from "vue-toast-notification";
import {
  createMonthlyReport,
  fetchReportPreviewHtml,
  getReportClients,
  openReportPdf,
  openReportHtml,
  printReportHtml,
  publishMonthlyReport,
  updateMonthlyReport,
  openUploadedReportPdf,
  deleteMonthlyReport,
} from "@/services/reportsService";
import type {
  GenerateMonthlyReportForm,
  ReportClientCard,
  ReportMonthSlot,
  ReportRecord,
  ReportSlotMode,
  ReportStatusMeta,
  ReportStatusTone,
} from "@/types/reports";

type ReportsPageRole = "super_admin" | "admin" | "member" | "client" | "guest";
type ReportStatusFilter = "all" | "none" | "partial" | "full";

interface SlotPreference {
  mode: ReportSlotMode;
  count: number;
}

const SLOT_PREF_KEY = "dmsuite.reports.slot-preferences";
const pageSize = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsView',
  setup(__props) {

const auth = useAuthStore();
const { canPermission } = useAccessControl();

const clients = ref<ReportClientCard[]>([]);
const loading = ref(true);
const error = ref<string | null>(null);
const builderOpen = ref(false);
const builderLoading = ref(false);
const builderError = ref<string | null>(null);
const selectedClient = ref<ReportClientCard | null>(null);
const selectedReport = ref<ReportRecord | null>(null);
const selectedMonthNumber = ref<number | null>(null);
const selectedPreviewReport = ref<ReportRecord | null>(null);
const selectedPreviewClient = ref<ReportClientCard | null>(null);
const isReportPreviewOpen = ref(false);
const isReportPreviewLoading = ref(false);
const reportPreviewHtml = ref("");
const reportPreviewError = ref<string | null>(null);
const quickEditOpen = ref(false);
const quickEditLoading = ref(false);
const quickEditError = ref<string | null>(null);
const selectedQuickEditReport = ref<ReportRecord | null>(null);
const selectedQuickEditClient = ref<ReportClientCard | null>(null);
const uploadOpen = ref(false);
const uploadMode = ref<"upload" | "update">("upload");
const uploadClient = ref<ReportClientCard | null>(null);
const uploadSlot = ref<ReportMonthSlot | null>(null);
const isGeneratingReport = ref(false);
const generationClientName = ref("");
const generationMonthLabel = ref("");
const generationError = ref<string | null>(null);
const isDownloadingPreviewPdf = ref(false);
const search = ref("");
const statusFilter = ref<ReportStatusFilter>("all");
const serviceFilter = ref("");
const currentPage = ref(1);
const expandedClientId = ref<string | null>(null);
const slotPreferences = reactive<Record<string, SlotPreference>>({});
const previewHtmlCache = reactive<Record<number, string>>({});
let previewRequestToken = 0;

// Master-detail state
const activeClientId = ref<string | null>(null);
const mobileShowingDetails = ref(false);
const customSlotModalOpen = ref(false);
const customSlotCountInput = ref(3);

const toast = useToast();
const deleteConfirmOpen = ref(false);
const isDeletingReport = ref(false);
const reportToDelete = ref<ReportRecord | null>(null);

const activeClient = computed(() => {
  if (!activeClientId.value) return null;
  return clients.value.find((c) => c.client_id === activeClientId.value) ?? null;
});

const activeClientSlots = computed(() => {
  return activeClient.value ? displaySlots(activeClient.value) : [];
});

const activeClientGeneratedCount = computed(() => {
  return activeClient.value ? generatedReportsCount(activeClient.value) : 0;
});

const activeClientTotalSlots = computed(() => {
  return activeClient.value ? displaySlotCount(activeClient.value) : 0;
});

const activeClientProgressPercentage = computed(() => {
  if (!activeClientTotalSlots.value) return 0;
  return Math.min(
    100,
    Math.round(
      (activeClientGeneratedCount.value / activeClientTotalSlots.value) * 100
    )
  );
});

function selectClient(client: ReportClientCard) {
  activeClientId.value = client.client_id;
  mobileShowingDetails.value = true;
}

function backToClientsList() {
  mobileShowingDetails.value = false;
}

function openCustomSlotModal() {
  if (!activeClient.value) return;
  const pref = slotPreference(activeClient.value.client_id);
  customSlotCountInput.value = pref.count;
  customSlotModalOpen.value = true;
}

function applyCustomSlotPreference() {
  if (!activeClient.value) return;
  const clientId = activeClient.value.client_id;
  updateSlotCount(clientId, customSlotCountInput.value);
  customSlotModalOpen.value = false;
  toast.success("Updated monthly report slots.");
}

function getClientInitials(name: string): string {
  if (!name) return "CL";
  const clean = name.trim();
  const words = clean.split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  const stopWords = new Set(["the", "of", "and", "for", "in", "to", "a", "an"]);
  const significant = words.filter((w) => !stopWords.has(w.toLowerCase()));
  if (significant.length >= 2) {
    return (significant[0][0] + significant[1][0]).toUpperCase();
  }
  return (words[0][0] + words[1][0]).toUpperCase();
}

const deleteConfirmDescription = computed(() => {
  if (!reportToDelete.value) {
    return "Are you sure you want to delete this report? This action cannot be undone.";
  }
  const month = reportToDelete.value.report_month_label || (reportToDelete.value.month_number ? `Month ${reportToDelete.value.month_number}` : "this month");
  const clientCode = reportToDelete.value.client_id;
  return `Are you sure you want to delete the ${month} report for client ${clientCode}? This will permanently remove the report, its data, and associated files.`;
});

const currentUserRole = computed<ReportsPageRole>(() => {
  if (auth.accountType === "client") return "client";
  if (auth.accountType !== "internal_user") return "guest";
  if (auth.isSuperAdmin) return "super_admin";
  if (auth.isProdOrMktgAdmin) return "admin";
  return "member";
});

const canGenerateReports = computed(() =>
  canPermission(ACCESS_PERMISSION_KEYS.REPORTS_GENERATE)
);
const canAiEditReports = computed(() =>
  canPermission(ACCESS_PERMISSION_KEYS.REPORTS_AI_EDIT) || canGenerateReports.value
);
const canViewReports = computed(() =>
  canPermission(ACCESS_PERMISSION_KEYS.REPORTS_VIEW)
);
const canExportReportPdf = computed(() =>
  canPermission(ACCESS_PERMISSION_KEYS.REPORTS_EXPORT_PDF)
);
const showAdminFilters = computed(() => currentUserRole.value !== "client");

const visibleClients = computed(() => clients.value);

const serviceFilterOptions = computed(() => {
  const values = new Set<string>();

  visibleClients.value.forEach((client) => {
    if (client.package_name) values.add(client.package_name);
    client.service_names.forEach((service) => values.add(service));
  });

  return Array.from(values).sort();
});

function slotStatusTone(status: string): ReportStatusTone {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "generated" || normalized === "published") return "green";
  if (normalized === "draft") return "amber";
  if (normalized === "in_progress") return "amber";
  if (normalized === "failed") return "rose";
  if (normalized === "not_generated") return "rose";
  return "slate";
}

function reportStatusLabel(status: string): string {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "generated" || normalized === "published")
    return "Generated";
  if (normalized === "draft") return "In Progress";
  if (normalized === "in_progress") return "In Progress";
  if (normalized === "failed") return "Failed";
  if (normalized === "not_generated") return "Not Generated";
  return "Not Generated";
}

function reportStatusDescription(status: string): string {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "generated" || normalized === "published") {
    return "This monthly report is ready for review and download.";
  }
  if (normalized === "draft") {
    return "The report is still being prepared.";
  }
  if (normalized === "in_progress") {
    return "The report is currently being generated.";
  }
  if (normalized === "failed") {
    return "The last generation attempt failed.";
  }
  return "No report has been generated for this month yet.";
}

function slotStatusMeta(slot: ReportMonthSlot): ReportStatusMeta {
  if (slot.report?.source_type === "uploaded") {
    return {
      label: reportStatusLabel(slot.status),
      description: "This monthly PDF report is ready for review.",
      tone: "green",
    };
  }
  return {
    label: reportStatusLabel(slot.status),
    description: reportStatusDescription(slot.status),
    tone: slotStatusTone(slot.status),
  };
}

function isReportReadyStatus(status: string | null | undefined): boolean {
  const normalized = String(status || "").toLowerCase();
  return normalized === "generated" || normalized === "published";
}

function generatedReportsCount(client: ReportClientCard): number {
  return displaySlots(client).filter((slot) =>
    isReportReadyStatus(slot.report?.status || slot.status)
  ).length;
}

function highestGeneratedMonthNumber(client: ReportClientCard): number {
  return client.max_generated_month_number ?? 0;
}

function slotPreference(clientId: string): SlotPreference {
  const stored = slotPreferences[clientId];
  if (stored) return stored;
  return {
    mode: "3",
    count: 3,
  };
}

function resolveBaseSlotCount(client: ReportClientCard): number {
  const preference = slotPreference(client.client_id);
  const highestGeneratedMonth = highestGeneratedMonthNumber(client);
  const base =
    preference.mode === "custom" ? preference.count : Number(preference.mode);

  if (!Number.isFinite(base) || base < 1) {
    return Math.max(1, highestGeneratedMonth);
  }

  return Math.max(base, highestGeneratedMonth, 1);
}

function displaySlotCount(client: ReportClientCard): number {
  return resolveBaseSlotCount(client);
}

function displaySlots(client: ReportClientCard): ReportMonthSlot[] {
  const visibleCount = displaySlotCount(client);
  const byMonth = new Map<number, ReportMonthSlot>();

  client.months.forEach((slot) => {
    byMonth.set(slot.month_number, slot);
  });

  return Array.from({ length: visibleCount }, (_, index) => {
    const monthNumber = index + 1;
    return (
      byMonth.get(monthNumber) ?? {
        month_number: monthNumber,
        report_month_label: `Month ${monthNumber}`,
        status: "not_generated",
        version: 0,
        last_generated_at: null,
        report: null,
      }
    );
  });
}

const filteredClients = computed(() => {
  const query = search.value.trim().toLowerCase();

  return visibleClients.value.filter((client) => {
    const matchesSearch =
      !query ||
      client.company_name.toLowerCase().includes(query) ||
      client.client_id.toLowerCase().includes(query) ||
      (client.package_name || "").toLowerCase().includes(query) ||
      client.service_names.some((service) =>
        service.toLowerCase().includes(query)
      );

    const slots = displaySlots(client);
    const generatedCount = slots.filter((slot) =>
      isReportReadyStatus(slot.report?.status || slot.status)
    ).length;
    const totalSlots = slots.length;

    const matchesStatus =
      statusFilter.value === "all" ||
      (statusFilter.value === "none" && generatedCount === 0) ||
      (statusFilter.value === "partial" &&
        generatedCount > 0 &&
        generatedCount < totalSlots) ||
      (statusFilter.value === "full" &&
        totalSlots > 0 &&
        generatedCount >= totalSlots);

    const matchesService =
      !serviceFilter.value ||
      client.package_name === serviceFilter.value ||
      client.service_names.includes(serviceFilter.value);

    return matchesSearch && matchesStatus && matchesService;
  });
});

const totalPages = computed(() =>
  Math.max(1, Math.ceil(filteredClients.value.length / pageSize))
);

const paginatedClients = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  return filteredClients.value.slice(start, start + pageSize);
});

const clientAccount = computed(() => visibleClients.value[0] ?? null);

const clientDisplaySlots = computed(() =>
  clientAccount.value ? displaySlots(clientAccount.value) : []
);

function setSearch(value: string) {
  search.value = value;
}

function setStatusFilter(value: string) {
  statusFilter.value = value as ReportStatusFilter;
}

function setServiceFilter(value: string) {
  serviceFilter.value = value;
}

function updateSlotMode(clientId: string, value: ReportSlotMode) {
  const current = slotPreference(clientId);
  slotPreferences[clientId] = {
    mode: value,
    count: value === "custom" ? Math.max(current.count, 1) : Number(value),
  };
  persistSlotPreferences();
}

function updateSlotCount(clientId: string, value: number) {
  const safeValue = Number.isFinite(value)
    ? Math.min(Math.max(Math.floor(value), 1), 12)
    : 1;
  const current = slotPreference(clientId);
  slotPreferences[clientId] = {
    mode: "custom",
    count: safeValue,
  };
  if (current.mode !== "custom" || current.count !== safeValue) {
    persistSlotPreferences();
  }
}

function persistSlotPreferences() {
  try {
    localStorage.setItem(SLOT_PREF_KEY, JSON.stringify(slotPreferences));
  } catch {
    /* ignore storage failures */
  }
}

function loadSlotPreferences() {
  try {
    const raw = localStorage.getItem(SLOT_PREF_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as Record<string, SlotPreference>;
    Object.entries(parsed).forEach(([clientId, preference]) => {
      if (!preference || typeof preference !== "object") return;
      const mode = ["1", "2", "3", "custom"].includes(preference.mode)
        ? preference.mode
        : "3";
      const count = Number.isFinite(preference.count)
        ? Math.min(Math.max(Math.floor(preference.count), 1), 12)
        : 3;
      slotPreferences[clientId] = {
        mode: mode as ReportSlotMode,
        count,
      };
    });
  } catch {
    /* ignore storage failures */
  }
}

function isClientExpanded(clientId: string) {
  return expandedClientId.value === clientId;
}

function toggleClient(clientId: string) {
  expandedClientId.value =
    expandedClientId.value === clientId ? null : clientId;
}

function monthSlotFor(client: ReportClientCard, monthNumber: number) {
  return (
    displaySlots(client).find((slot) => slot.month_number === monthNumber) ??
    null
  );
}

function reportById(reportId: number | null) {
  if (!reportId) return null;
  for (const client of visibleClients.value) {
    const slot = client.months.find((item) => item.report?.id === reportId);
    if (slot?.report) return slot.report;
  }
  return null;
}

function openBuilder(
  client?: ReportClientCard | null,
  slotOrReport?: ReportMonthSlot | ReportRecord | null
) {
  selectedClient.value = client || null;
  selectedReport.value = slotOrReport
    ? "report" in slotOrReport
      ? slotOrReport.report || null
      : "preview_html_url" in slotOrReport || "preview_url" in slotOrReport
        ? slotOrReport
        : null
    : null;
  selectedMonthNumber.value = slotOrReport ? slotOrReport.month_number : null;
  builderError.value = null;
  builderOpen.value = true;
}

function openUpload(client: ReportClientCard, slot: ReportMonthSlot | null) {
  if (!slot) return;
  uploadClient.value = client;
  uploadSlot.value = slot;
  uploadMode.value = "upload";
  uploadOpen.value = true;
}

function openUpdateUpload(client: ReportClientCard, slot: ReportMonthSlot | null) {
  if (!slot?.report) return;
  uploadClient.value = client;
  uploadSlot.value = slot;
  uploadMode.value = "update";
  uploadOpen.value = true;
}

async function handleUploaded(report: ReportRecord) {
  await refresh();
  const context = reportContextById(report.id);
  if (context) uploadSlot.value = displaySlots(context.client as ReportClientCard).find((slot) => slot.report?.id === report.id) || uploadSlot.value;
}

async function loadPreview(
  report: ReportRecord,
  client: ReportClientCard | null
) {
  selectedPreviewReport.value = report;
  selectedPreviewClient.value = client;
  reportPreviewError.value = null;
  isReportPreviewOpen.value = true;

  if (previewHtmlCache[report.id]) {
    reportPreviewHtml.value = previewHtmlCache[report.id];
    isReportPreviewLoading.value = false;
    return;
  }

  reportPreviewHtml.value = "";
  isReportPreviewLoading.value = true;

  const requestToken = ++previewRequestToken;

  try {
    const html = await fetchReportPreviewHtml(report);
    if (requestToken !== previewRequestToken) return;
    if (!String(html || "").trim()) {
      reportPreviewError.value = "The generated preview was empty. Please try reopening the report.";
      reportPreviewHtml.value = "";
      return;
    }
    previewHtmlCache[report.id] = html;
    reportPreviewHtml.value = html;
  } catch (err: any) {
    if (requestToken !== previewRequestToken) return;
    reportPreviewError.value =
      err?.response?.data?.message || "Unable to load the report preview.";
  } finally {
    if (requestToken === previewRequestToken) {
      isReportPreviewLoading.value = false;
    }
  }
}

async function refreshReportPreview() {
  if (!selectedPreviewReport.value) return;
  const report = selectedPreviewReport.value;
  delete previewHtmlCache[report.id];
  try {
    const html = await fetchReportPreviewHtml(report);
    previewHtmlCache[report.id] = html;
    reportPreviewHtml.value = html;
  } catch (err: any) {
    reportPreviewError.value =
      err?.response?.data?.message || "Unable to refresh the report preview.";
  }
}

function openPreviewById(reportId: number | null) {
  const context = reportContextById(reportId);
  if (!context) return;
  if (context.report.source_type === "uploaded") {
    void openUploadedReportPdf(context.report).catch((err: any) => {
      error.value =
        err?.response?.data?.message ||
        err?.message ||
        "Unable to open the uploaded PDF.";
    });
    return;
  }
  void loadPreview(context.report, context.client);
}

function editSelectedPreviewReport() {
  if (!selectedPreviewReport.value || !selectedPreviewClient.value) return;
  isReportPreviewOpen.value = false;
  selectedQuickEditReport.value = selectedPreviewReport.value;
  selectedQuickEditClient.value = selectedPreviewClient.value;
  quickEditError.value = null;
  quickEditOpen.value = true;
}

async function handleQuickEditSave(fields: {
  title: string;
  prepared_by: string;
  executive_snapshot_note: string;
  overall_recommendation_summary: string;
  sections: Record<string, {
    enabled: boolean;
    summary?: string;
    insight: string;
    recommendation?: string;
  }>;
}) {
  if (!selectedQuickEditReport.value) return;

  quickEditLoading.value = true;
  quickEditError.value = null;

  try {
    const report = selectedQuickEditReport.value;
    const existingData = (report.report_data || {}) as Record<string, any>;
    const mergedSections = { ...(existingData.sections || {}) };

    Object.entries(fields.sections || {}).forEach(([secKey, secVal]) => {
      mergedSections[secKey] = {
        ...(mergedSections[secKey] || {}),
        ...(secVal.summary !== undefined ? { summary: secVal.summary } : {}),
        insight: secVal.insight,
        recommendation: secVal.recommendation,
      };
    });

    const payload: GenerateMonthlyReportForm = {
      client_id: report.client_id,
      month_number: report.month_number,
      report_month_label: report.report_month_label,
      title: fields.title,
      date_from: report.date_from || "",
      date_to: report.date_to || "",
      selected_sections: report.selected_sections || [],
      report_data_json: JSON.stringify({
        ...existingData,
        prepared_by: fields.prepared_by,
        executive_snapshot_note: fields.executive_snapshot_note,
        overall_recommendation_summary: fields.overall_recommendation_summary,
        sections: mergedSections,
        social_media_insight: fields.sections?.socialMediaPerformance?.insight || existingData.social_media_insight,
        social_media_recommendation: fields.sections?.socialMediaPerformance?.recommendation || existingData.social_media_recommendation,
        ai_chatbot_insight: fields.sections?.aiChatbotManagement?.insight || existingData.ai_chatbot_insight,
        ai_chatbot_recommendation: fields.sections?.aiChatbotManagement?.recommendation || existingData.ai_chatbot_recommendation,
        ai_podcast_insight: fields.sections?.aiPodcastProgress?.insight || existingData.ai_podcast_insight,
        ai_podcast_recommendation: fields.sections?.aiPodcastProgress?.recommendation || existingData.ai_podcast_recommendation,
        seo_ads_insight: fields.sections?.seoManagement?.insight || existingData.seo_ads_insight,
        seo_summary: fields.sections?.seoManagement?.summary || existingData.seo_summary,
        seo_recommendation: fields.sections?.seoManagement?.recommendation || existingData.seo_recommendation,
        blog_insight: fields.sections?.blogManagement?.insight || existingData.blog_insight,
        blog_recommendation: fields.sections?.blogManagement?.recommendation || existingData.blog_recommendation,
      }),
      publish: report.status === "published",
      status:
        report.status === "published"
          ? "published"
          : report.status === "draft"
            ? "draft"
            : report.status === "archived"
              ? "archived"
              : "generated",
      version: report.version,
    };

    const savedReport = await updateMonthlyReport(report.id, payload, {
      cover_assets: [],
      social_media_assets: [],
    });

    delete previewHtmlCache[report.id];
    await refresh();
    quickEditOpen.value = false;
    selectedQuickEditReport.value = savedReport;
    await loadPreview(savedReport, selectedQuickEditClient.value);
  } catch (err: any) {
    quickEditError.value =
      err?.response?.data?.message || "Unable to save report changes.";
  } finally {
    quickEditLoading.value = false;
  }
}

function openPdfById(reportId: number | null) {
  const report = reportById(reportId);
  if (report) {
    if (report.source_type === "uploaded") {
      void openUploadedReportPdf(report);
    } else {
      void printReportHtml(report);
    }
  }
}

function openHtmlById(reportId: number | null) {
  const report = reportById(reportId);
  if (report) {
    void openReportHtml(report).catch((err: any) => {
      error.value =
        err?.response?.data?.message || err?.message || "Unable to open the report page.";
    });
  }
}

function openSelectedPreviewFullPage() {
  if (selectedPreviewReport.value) {
    const preloaded =
      reportPreviewHtml.value ||
      previewHtmlCache[selectedPreviewReport.value.id] ||
      "";
    void openReportHtml(selectedPreviewReport.value, preloaded).catch((err: any) => {
      console.warn("Unable to open the full report page:", err);
    });
  }
}

function confirmDeleteReport(report: ReportRecord | null) {
  if (!report) return;
  reportToDelete.value = report;
  deleteConfirmOpen.value = true;
}

async function handleConfirmDeleteReport() {
  if (!reportToDelete.value) return;
  const targetId = reportToDelete.value.id;
  try {
    isDeletingReport.value = true;
    await deleteMonthlyReport(targetId);
    toast.success("Report deleted successfully.");
    delete previewHtmlCache[targetId];
    deleteConfirmOpen.value = false;
    if (selectedPreviewReport.value?.id === targetId) {
      isReportPreviewOpen.value = false;
      selectedPreviewReport.value = null;
    }
    reportToDelete.value = null;
    await refresh();
  } catch (err: any) {
    const message = err?.response?.data?.message || err?.message || "Failed to delete report.";
    toast.error(message);
  } finally {
    isDeletingReport.value = false;
  }
}

function expandedEmptyMessage(): string {
  if (canGenerateReports.value) {
    return "No reports have been generated for this client yet.";
  }

  if (currentUserRole.value === "member") {
    return "Reports are not available yet.";
  }

  if (currentUserRole.value === "client") {
    return "Reports are not available yet.";
  }

  return "No reports have been generated for this client yet.";
}

async function refresh() {
  loading.value = true;
  error.value = null;
  try {
    const response = await getReportClients();
    clients.value = response;

    if (currentPage.value > totalPages.value) {
      currentPage.value = totalPages.value;
    }
  } catch (err: any) {
    error.value = err?.response?.data?.message || "Unable to load reports.";
  } finally {
    loading.value = false;
  }
}

function reportContextById(
  reportId: number | null
): { report: ReportRecord; client: ReportClientCard | null } | null {
  if (!reportId) return null;

  for (const client of visibleClients.value) {
    const slot = client.months.find((item) => item.report?.id === reportId);
    if (slot?.report) {
      return { report: slot.report, client };
    }
  }

  return null;
}

function handleDismissGeneration() {
  isGeneratingReport.value = false;
  if (generationError.value) {
    builderOpen.value = true;
    builderError.value = generationError.value;
  }
}

async function handleDownloadPreviewPdf() {
  if (!selectedPreviewReport.value) return;
  isDownloadingPreviewPdf.value = true;
  try {
    if (selectedPreviewReport.value.source_type === "uploaded") {
      await openUploadedReportPdf(selectedPreviewReport.value);
    } else {
      await printReportHtml(selectedPreviewReport.value);
    }
  } catch (err: any) {
    reportPreviewError.value =
      err?.response?.data?.message || err?.message || "Unable to download the PDF report.";
  } finally {
    isDownloadingPreviewPdf.value = false;
  }
}

async function handleGenerate(payload: {
  payload: GenerateMonthlyReportForm;
  files: Record<string, File[]>;
  action: "draft" | "html" | "pdf" | "generate";
  reportId?: number | null;
  extractedPayload?: Record<string, string>;
}) {
  if (payload.action === "draft") {
    builderLoading.value = true;
    builderError.value = null;

    try {
      await (payload.reportId
        ? updateMonthlyReport(
            payload.reportId,
            payload.payload,
            payload.files,
            payload.extractedPayload
          )
        : createMonthlyReport(payload.payload, payload.files, payload.extractedPayload));

      await refresh();
      builderOpen.value = false;
    } catch (err: any) {
      builderError.value =
        err?.response?.data?.message || err?.message || "Unable to save report draft.";
    } finally {
      builderLoading.value = false;
    }
    return;
  }

  const targetClient = clients.value.find((c) => c.client_id === payload.payload.client_id);
  generationClientName.value = targetClient?.company_name || "Client";
  generationMonthLabel.value = `Month ${payload.payload.month_number}`;
  generationError.value = null;
  isGeneratingReport.value = true;
  builderOpen.value = false;

  try {
    const savedReport = payload.reportId
      ? await updateMonthlyReport(
          payload.reportId,
          payload.payload,
          payload.files,
          payload.extractedPayload
        )
      : await createMonthlyReport(payload.payload, payload.files, payload.extractedPayload);

    if (payload.action === "pdf") {
      const publishedReport = await publishMonthlyReport(savedReport.id);
      await refresh();
      isGeneratingReport.value = false;
      await printReportHtml(publishedReport);
      return;
    }

    if (payload.action === "html" || payload.action === "generate") {
      const reportToPreview =
        payload.action === "generate"
          ? await publishMonthlyReport(savedReport.id)
          : savedReport;

      // Invalidate preview cache so fresh report is loaded
      delete previewHtmlCache[reportToPreview.id];

      await refresh();
      isGeneratingReport.value = false;
      await loadPreview(reportToPreview, selectedClient.value);
      return;
    }
  } catch (err: any) {
    generationError.value =
      err?.response?.data?.message || "Unable to generate the report.";
  }
}

watch([search, serviceFilter, statusFilter], () => {
  currentPage.value = 1;
});

watch(
  () => paginatedClients.value.map((client) => client.client_id).join("|"),
  () => {
    if (
      expandedClientId.value &&
      !paginatedClients.value.some(
        (client) => client.client_id === expandedClientId.value
      )
    ) {
      expandedClientId.value = null;
    }
  }
);

watch(
  () => filteredClients.value.length,
  () => {
    if (currentPage.value > totalPages.value) {
      currentPage.value = totalPages.value;
    }
  }
);

onMounted(() => {
  loadSlotPreferences();
  refresh();
});

watch(isReportPreviewOpen, (open) => {
  if (!open) {
    previewRequestToken += 1;
    isReportPreviewLoading.value = false;
  }
});

watch(quickEditOpen, (open) => {
  if (!open) {
    quickEditLoading.value = false;
    quickEditError.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "space-y-2" }, [
            _createElementVNode("span", { class: "inline-flex rounded-full bg-[#eaf3fb] px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.08em] text-[#2f6fab]" }, " Reports "),
            _createElementVNode("div", null, [
              _createElementVNode("h1", { class: "text-[2rem] font-black leading-tight text-[#0f172a]" }, " Reports "),
              _createElementVNode("p", { class: "mt-2 max-w-3xl text-[0.95rem] text-[#64748b]" }, " Review your account’s monthly performance, progress updates, and downloadable reports. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "action-btn action-btn--light",
              onClick: refresh
            }, [
              _createVNode(_unref(RefreshCw), {
                class: _normalizeClass(["h-4 w-4", { 'animate-spin': loading.value }])
              }, null, 8, ["class"]),
              _cache[11] || (_cache[11] = _createTextVNode(" Refresh ", -1))
            ]),
            (canGenerateReports.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "action-btn action-btn--dark",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openBuilder()))
                }, [
                  _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                  _cache[12] || (_cache[12] = _createTextVNode(" Generate Report ", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (error.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_6, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "h-5 w-24 bg-slate-200 animate-pulse rounded" }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "h-10 w-full bg-slate-100 animate-pulse rounded-[0.95rem]" }, null, -1)),
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "h-9 w-full bg-slate-100 animate-pulse rounded-[0.95rem]" }, null, -1)),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "h-16 bg-slate-50 animate-pulse rounded-[1rem]"
                  })
                }), 64))
              ])
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "space-y-4" }, [
              _createElementVNode("div", { class: "h-28 rounded-[1.4rem] border border-[#d8e4f0] bg-white p-6 animate-pulse" }),
              _createElementVNode("div", { class: "h-64 rounded-[1.4rem] border border-[#d8e4f0] bg-white p-6 animate-pulse" })
            ], -1))
          ]))
        : (currentUserRole.value === 'client')
          ? (_openBlock(), _createBlock(ClientReportsView, {
              key: 2,
              client: clientAccount.value,
              slots: clientDisplaySlots.value,
              "status-meta": slotStatusMeta,
              "can-view": canViewReports.value,
              "can-download": canExportReportPdf.value,
              onViewReport: openPreviewById,
              onDownloadPdf: openPdfById
            }, null, 8, ["client", "slots", "can-view", "can-download"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("aside", {
                class: _normalizeClass(["rounded-[1.4rem] border border-[#d8e4f0] bg-white p-5 shadow-[0_10px_22px_rgba(15,23,42,0.04)] space-y-4", { 'hidden lg:block': mobileShowingDetails.value && activeClient.value }])
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-[1.15rem] font-extrabold text-[#0f172a]" }, " Clients ", -1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(filteredClients.value.length), 1)
                ]),
                _createVNode(ReportFilters, {
                  search: search.value,
                  "status-filter": statusFilter.value,
                  "service-filter": serviceFilter.value,
                  "service-options": serviceFilterOptions.value,
                  "show-service-filter": true,
                  "onUpdate:search": setSearch,
                  "onUpdate:statusFilter": setStatusFilter,
                  "onUpdate:serviceFilter": setServiceFilter
                }, null, 8, ["search", "status-filter", "service-filter", "service-options"]),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedClients.value, (client) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: client.client_id,
                      type: "button",
                      class: _normalizeClass(["w-full flex items-center justify-between gap-3 rounded-[1rem] p-3 text-left transition hover:-translate-y-0.5", activeClientId.value === client.client_id
                ? 'border border-[#8eb4ff] bg-[#eaf3fb]/80 ring-2 ring-[#8eb4ff]/40 shadow-[0_4px_12px_rgba(47,111,171,0.08)]'
                : 'border border-[#eef2f7] hover:border-[#bfd0e6] bg-[#fbfdff] hover:bg-white']),
                      onClick: ($event: any) => (selectClient(client))
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-xs font-black transition", activeClientId.value === client.client_id
                    ? 'bg-[#2f6fab] text-white'
                    : 'bg-[#eaf3fb] text-[#2f6fab]'])
                        }, _toDisplayString(getClientInitials(client.company_name)), 3),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("p", _hoisted_17, _toDisplayString(client.company_name), 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(client.client_id), 1)
                        ])
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["shrink-0 rounded-full px-2.5 py-1 text-[0.7rem] font-extrabold uppercase tracking-[0.08em] transition", activeClientId.value === client.client_id
                  ? 'bg-[#2f6fab] text-white'
                  : 'bg-[#eef4ff] text-[#3556a8]'])
                      }, _toDisplayString(generatedReportsCount(client)) + "/" + _toDisplayString(displaySlotCount(client)) + " ready ", 3)
                    ], 10, _hoisted_14))
                  }), 128)),
                  (!paginatedClients.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, " No clients match the current filters. "))
                    : _createCommentVNode("", true)
                ]),
                (filteredClients.value.length)
                  ? (_openBlock(), _createBlock(ReportPagination, {
                      key: 0,
                      "current-page": currentPage.value,
                      "total-pages": totalPages.value,
                      "total-items": filteredClients.value.length,
                      "page-size": pageSize,
                      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (currentPage.value = $event))
                    }, null, 8, ["current-page", "total-pages", "total-items"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("main", {
                class: _normalizeClass(["space-y-5 min-w-0", { 'hidden lg:block': !mobileShowingDetails.value && !activeClient.value }])
              }, [
                (activeClient.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center gap-2 rounded-[0.85rem] border border-[#d7e2ef] bg-[#f6f9ff] px-3.5 py-2 text-xs font-extrabold text-[#2855a6] transition hover:-translate-y-0.5",
                        onClick: backToClientsList
                      }, [
                        _createVNode(_unref(ArrowLeft), { class: "h-3.5 w-3.5" }),
                        _cache[19] || (_cache[19] = _createTextVNode(" Back to clients ", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (activeClient.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("section", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(getClientInitials(activeClient.value.company_name)), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("h2", _hoisted_26, _toDisplayString(activeClient.value.company_name), 1),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(activeClient.value.client_id), 1)
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mt-1 text-[0.9rem] font-medium text-[#64748b]" }, " Monthly performance reports ", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(activeClientGeneratedCount.value) + " of " + _toDisplayString(activeClientTotalSlots.value) + " ready ", 1),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", {
                              class: "h-full rounded-full bg-[#173b5f] transition-all duration-500",
                              style: _normalizeStyle({ width: activeClientProgressPercentage.value + '%' })
                            }, null, 4)
                          ])
                        ])
                      ]),
                      _createElementVNode("section", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                            _createElementVNode("h2", { class: "text-[1.25rem] font-extrabold text-[#0f172a]" }, " Monthly reports "),
                            _createElementVNode("p", { class: "text-[0.9rem] text-[#64748b]" }, " One report for each month. ")
                          ], -1)),
                          (canGenerateReports.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "action-btn action-btn--light",
                                onClick: openCustomSlotModal
                              }, [
                                _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                                _cache[21] || (_cache[21] = _createTextVNode(" Custom ", -1))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeClientSlots.value, (slot) => {
                            return (_openBlock(), _createBlock(MonthlyReportCard, {
                              key: `${activeClient.value.client_id}-${slot.month_number}`,
                              "month-slot": slot,
                              "can-generate": canGenerateReports.value && (!slot.report || slot.status === 'draft'),
                              "can-view": !!slot.report && ['generated', 'published'].includes(String(slot.report.status || slot.status).toLowerCase()),
                              "can-download": false,
                              "can-delete": canGenerateReports.value,
                              "can-upload": canGenerateReports.value,
                              "can-update": !!slot.report?.can_update && canGenerateReports.value,
                              "show-html-actions": false,
                              "empty-message": 'No report has been generated for this month yet.',
                              "status-meta": slotStatusMeta(slot),
                              "is-custom": slot.month_number > 3,
                              onGenerate: ($event: any) => (openBuilder(activeClient.value, slot)),
                              onView: ($event: any) => (openPreviewById(slot.report?.id || null)),
                              onDownloadPdf: ($event: any) => (openPdfById(slot.report?.id || null)),
                              onDownloadHtml: ($event: any) => (openHtmlById(slot.report?.id || null)),
                              onUpload: ($event: any) => (openUpload(activeClient.value, slot)),
                              onUpdateReport: ($event: any) => (openUpdateUpload(activeClient.value, slot)),
                              onDeleteReport: ($event: any) => (confirmDeleteReport(slot.report))
                            }, null, 8, ["month-slot", "can-generate", "can-view", "can-delete", "can-upload", "can-update", "status-meta", "is-custom", "onGenerate", "onView", "onDownloadPdf", "onDownloadHtml", "onUpload", "onUpdateReport", "onDeleteReport"]))
                          }), 128))
                        ]),
                        _createElementVNode("p", _hoisted_34, [
                          _createVNode(_unref(Info), { class: "h-4 w-4 text-[#94a3b8]" }),
                          _cache[23] || (_cache[23] = _createTextVNode(" Custom months appear at the bottom of this list. ", -1))
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_unref(FileText), { class: "h-8 w-8" })
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "text-[1.25rem] font-black text-[#0f172a]" }, " Select a Client ", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-2 max-w-sm text-[0.92rem] text-[#64748b] leading-relaxed" }, " Choose a client from the list on the left to review their monthly performance, generate reports, and copy share links. ", -1))
                    ]))
              ], 2)
            ]))
    ]),
    (customSlotModalOpen.value && activeClient.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "text-[1.05rem] font-extrabold text-[#0f172a]" }, " Monthly Slots Setup ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "text-[#94a3b8] hover:text-[#475569]",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (customSlotModalOpen.value = false))
              }, [
                _createVNode(_unref(X), { class: "h-5 w-5" })
              ])
            ]),
            _createElementVNode("p", _hoisted_40, [
              _cache[27] || (_cache[27] = _createTextVNode(" Configure how many monthly report slots to display for ", -1)),
              _createElementVNode("span", _hoisted_41, _toDisplayString(activeClient.value.company_name), 1),
              _cache[28] || (_cache[28] = _createTextVNode(". ", -1))
            ]),
            _createElementVNode("div", _hoisted_42, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-[0.72rem] font-extrabold text-[#748197] uppercase tracking-[0.08em]" }, " Custom Month Count (1 - 12) ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customSlotCountInput).value = $event)),
                type: "number",
                min: "1",
                max: "12",
                class: "w-full rounded-[0.85rem] border border-[#d3dce9] px-3.5 py-2.5 text-sm font-semibold text-[#243049] outline-none focus:border-[#8eb4ff] focus:ring-2 focus:ring-[#cfe0ff]"
              }, null, 512), [
                [
                  _vModelText,
                  customSlotCountInput.value,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("button", {
                type: "button",
                class: "action-btn action-btn--light !py-2 !px-3.5 !text-[0.85rem]",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (customSlotModalOpen.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                type: "button",
                class: "action-btn action-btn--dark !py-2 !px-3.5 !text-[0.85rem]",
                onClick: applyCustomSlotPreference
              }, " Apply ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ReportBuilderModal, {
      open: builderOpen.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((builderOpen).value = $event)),
      clients: clients.value,
      "selected-client": selectedClient.value,
      "selected-month-number": selectedMonthNumber.value,
      report: selectedReport.value,
      mode: selectedReport.value ? 'edit' : 'create',
      loading: builderLoading.value,
      error: builderError.value,
      onGenerate: handleGenerate
    }, null, 8, ["open", "clients", "selected-client", "selected-month-number", "report", "mode", "loading", "error"]),
    _createVNode(ReportGenerationLoadingModal, {
      open: isGeneratingReport.value,
      "client-name": generationClientName.value,
      "month-label": generationMonthLabel.value,
      error: generationError.value,
      onDismiss: handleDismissGeneration
    }, null, 8, ["open", "client-name", "month-label", "error"]),
    _createVNode(ReportPreviewDialog, {
      open: isReportPreviewOpen.value,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((isReportPreviewOpen).value = $event)),
      report: selectedPreviewReport.value,
      client: selectedPreviewClient.value,
      role: currentUserRole.value,
      loading: isReportPreviewLoading.value,
      error: reportPreviewError.value,
      html: reportPreviewHtml.value,
      "can-edit": canGenerateReports.value,
      "can-ai-edit": canAiEditReports.value,
      "can-open-full-page": canViewReports.value,
      "can-download": canViewReports.value || canGenerateReports.value,
      "can-delete": canGenerateReports.value,
      downloading: isDownloadingPreviewPdf.value,
      onEditReport: editSelectedPreviewReport,
      onOpenFullPage: openSelectedPreviewFullPage,
      onDownloadPdf: handleDownloadPreviewPdf,
      onDeleteReport: _cache[7] || (_cache[7] = ($event: any) => (confirmDeleteReport(selectedPreviewReport.value))),
      onRefreshReport: refreshReportPreview
    }, null, 8, ["open", "report", "client", "role", "loading", "error", "html", "can-edit", "can-ai-edit", "can-open-full-page", "can-download", "can-delete", "downloading"]),
    _createVNode(ReportQuickEditDialog, {
      open: quickEditOpen.value,
      "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((quickEditOpen).value = $event)),
      report: selectedQuickEditReport.value,
      loading: quickEditLoading.value,
      error: quickEditError.value,
      onSave: handleQuickEditSave
    }, null, 8, ["open", "report", "loading", "error"]),
    _createVNode(UploadReportModal, {
      open: uploadOpen.value,
      "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((uploadOpen).value = $event)),
      mode: uploadMode.value,
      "client-id": uploadClient.value?.client_id || '',
      "client-code": uploadClient.value?.client_id,
      "client-name": uploadClient.value?.company_name || '',
      "month-number": uploadSlot.value?.month_number || 1,
      "month-label": uploadSlot.value?.report_month_label || '',
      "date-from": uploadSlot.value?.report?.date_from,
      "date-to": uploadSlot.value?.report?.date_to,
      "existing-report": uploadSlot.value?.report,
      onUploaded: handleUploaded,
      onUpdated: handleUploaded
    }, null, 8, ["open", "mode", "client-id", "client-code", "client-name", "month-number", "month-label", "date-from", "date-to", "existing-report"]),
    _createVNode(ConfirmDialog, {
      open: deleteConfirmOpen.value,
      title: "Delete Monthly Report",
      description: deleteConfirmDescription.value,
      "btn-text": "Delete Report",
      "btn-color": "bg-[#dc2626] hover:bg-[#b91c1c]",
      busy: isDeletingReport.value,
      "busy-text": "Deleting...",
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => (deleteConfirmOpen.value = $event)),
      onAction: handleConfirmDeleteReport
    }, null, 8, ["open", "description", "busy"])
  ]))
}
}

})